import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Customer
export const getCustomersAgentService = (params) => {
  return http.get(`${base_url}/agent/customers`, { params });
};
export const createCustomerAgentService = (data) => {
  return http.post(`${base_url}/agent/customer`, data);
};
export const editCustomerAgentService = (data) => {
  return http.put(`${base_url}/agent/customer/${data.id}`, data);
};
export const changeCustomerActiveAgentService = (id) => {
  return http.patch(`${base_url}/agent/customer/${id}/active`);
};
export const changeCustomerPasswordAgentService = (data) => {
  return http.patch(
    `${base_url}/agent/customer/${data.id}/change-password`,
    data
  );
};
export const deleteCustomerAgentService = (id) => {
  return http.delete(`${base_url}/agent/customer/${id}`);
};
// End Customer

// Start Transaction
export const createTransferTransactionAgentService = (data) => {
  return http.patch(`${base_url}/agent/transaction/transfer`, data);
};
// End Transaction

// Start Overview
export const getOverviewAgentService = (params) => {
  return http.get(`${base_url}/agent/overview`, { params });
};
// End Overview
